
(function() {
  function initExternalLinks() {
    const links = document.querySelectorAll('a');
    const currentHost = window.location.hostname;

    links.forEach(link => {
      if (link.href && link.hostname) {
        const isExternal = link.hostname !== currentHost;
        const isWebProtocol = link.protocol === 'http:' || link.protocol === 'https:';

        if (isExternal && isWebProtocol) {
          link.setAttribute('target', '_blank');
          link.setAttribute('rel', 'noopener noreferrer');
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initExternalLinks);
  } else {
    initExternalLinks();
  }
})();